<template>
  <div>
    <h4>{{title}}</h4>
    <div class="report_table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th @click="sort('tujuan')">Destination {{ (orderBy == 'tujuan') ? (direction == 'ASC') ? '▲' : '▼' : '' }}</th>
            <th @click="sort('count')">Total {{ (orderBy == 'count') ? (direction == 'ASC') ? '▲' : '▼' : '' }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="dat in data">
            <td>{{ dat.tujuan }}</td>
            <td>{{ numberWithCommas(dat.count) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        data : null,
        orderBy : 'tujuan',
        direction : 'ASC'
      }
    },
    props : ['filterUrl', 'api_url', 'title'],
    mounted () {

    },
    watch : {
      filterUrl : {
        handler(){
          if(this.filterUrl != null && this.filterUrl != ''){
            this.fetchData()
          }
        },
        immediate : true
      }
    },
    methods : {
      sort(variable){
        if(this.orderBy == variable){
          this.direction = (this.direction == 'ASC') ? 'DESC' : 'ASC'
        } else {
          this.orderBy = variable;
          this.direction = 'ASC'
        }
        this.fetchData();
      },
      fetchData(){
        this.$http.get(`${this.api_url}?${this.filterUrl}&orderBy=${this.orderBy}&direction=${this.direction}`)
        .then((resp)=>{
          this.data = resp.data.data.stock;
        })
        .catch((err)=>{
          console.log(err);
        })
      },
    }
  }
</script>

<style scoped>
  .report_table{
    height:700px;
    overflow-y:auto;
  }

  table thead tr th:hover{
    cursor: pointer;
  }
</style>